import { Component, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "app/base-module/base-service/auth.service";
import { Usuario } from "app/usuarios/models/user.model";
import { ActionDialog, BaseComponent } from "../../base-module/base-component/base.component";
import { CadastroEmpresaConsorcioComponent } from "../cadastro-empresa-consorcio/cadastro-empresa-consorcio.component";
import { EmpresaConsorcioService } from "../services/empresa-consorcio.service";

@Component({
    selector: "app-lista-empresa-consorcio",
    templateUrl: "./lista-empresa-consorcio.component.html",
    styleUrls: ["./lista-empresa-consorcio.component.scss"],
})
export class ListaEmpresaCosorcioComponent extends BaseComponent {
    user: Usuario | null = null;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(ListaEmpresaCosorcioComponent, { static: false }) table!: ListaEmpresaCosorcioComponent;

    constructor(
        public _service: EmpresaConsorcioService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private _authService: AuthService
    ) {
        super(dialog, snackBar);

        this.getAll();
        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event - Evento de paginação
     * @returns {void}
     */
    pageEvent(event: PageEvent): void {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    /**
     * Consulta lista de Empresa Consórcio
     * @returns {void}
     */
    getAll(): void {
        this.loadingIndicator = true;
        this._service.getAll(this.params).subscribe({
            next: (data) => {
                this.length = data.meta?.total ?? 0;
                this.rows = data.data ?? [];
                this.temp = [...this.rows];
            },
            error: (error) => {
                this.loadingIndicator = false;
                this.showError(`Erro ao buscar empresas: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingIndicator = false;
            },
        });
    }

    /**
     * Exclui Empresa Consórcio
     * @param {number} id - ID da empresa a ser excluída
     * @returns {void}
     */
    delete(id: number): void {
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            data: {
                title: "Excluir Empresa",
                text: "Deseja realmente excluir este item?",
                callback: () => {
                    this.dialog.closeAll();

                    this.loadingIndicator = true;
                    this._service.delete(id).subscribe({
                        next: (data) => {
                            this.loadingIndicator = false;
                            this.showSuccess(data.message);
                            this.getAll();
                        },
                        error: (error) => {
                            this.loadingIndicator = false;
                            this.showError(`Erro ao excluir empresa: ${error.error?.message || error.message}`);
                        },
                        complete: () => {
                            // Loading será fechado em next ou error
                        },
                    });
                },
            },
        });
    }

    /**
     * Abre modal de cadastro
     * @returns {void}
     */
    openCadastro(): void {
        const dialogRef = this.dialog.open(CadastroEmpresaConsorcioComponent, {
            width: "400px",
            height: "80%",
        });

        dialogRef.afterClosed().subscribe((result: unknown) => {
            if (result !== undefined && result !== null && result !== "cancel") {
                this.showSuccess("Empresa cadastrado com sucesso!");
                this.getAll();
            }
        });
    }

    /**
     * Abre modal de edição
     * @param {number} id - ID da empresa a ser editada
     * @returns {void}
     */
    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(CadastroEmpresaConsorcioComponent, {
            width: "400px",
            height: "80%",
            data: {
                id: id,
            },
        });

        dialogRef.afterClosed().subscribe((result: unknown) => {
            if (result !== undefined && result !== null && result !== "cancel") {
                this.showSuccess("Empresa atualizado com sucesso!");
                this.getAll();
            }
        });
    }
}
